<template>
  <div>
    <b-card>
      <div>
        <page-header
          @reset="reset"
          @add="add"
          @delRows="delRows"
          slot="header"
          @submit="handleSubmit"
          ref="header"
        />
      </div>
      <page-main ref="main" :table-data="table" :loading="loading" @submit="reload" />
      <js-pagination
        class="mt-2"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="sm"
        align="right"
        @change="handlePaginationChange"
      />
    </b-card>
  </div>
</template>

<script>
export default {
  name: "resourceManagement-researchDictionary",
  components: {
    PageHeader: () => import("./components/header"),
    PageMain: () => import("./components/main"),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  methods: {
    reset () {
       this.page = {
            curPage: 1,
            pageSize: 10,
            pageTotal: 0
        }
    },
    add() {
      this.$refs.main.fromLoad("add");
    },
    delRows() {
      this.$refs.main.delRows();
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      };
      this.$nextTick(() => {
        this.$refs.header.query();
      });
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset();
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true;
      this.$api
        .listResearchTagApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false;
          this.page.pageTotal = res.body.count;
          this.table = res.body.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
